import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import "./contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faWhatsapp,
  faInstagram,
  faFacebook,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResponseMessage("");
    setError("");

    try {
      const res = await fetch(
        "https://api.deepticentre.com/deeptischool/contact-us",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (res.ok) {
        setResponseMessage("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setError("Failed to send message. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <Container className="contact-us-section py-5">
      <Row className="mb-4 text-center">
        <Col>
          <h2 className="contact-title text-uppercase">Contact Us</h2>
          <p className="contact-quotes">
            "Every child is gifted. They just unwrap their gifts at different
            times."
            <br />
            Let’s connect and support your child’s unique journey.
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center mt-5">
        <Col md={5} className="contact-info p-4">
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <h4 className="get-in-touch mb-4 fw-bold">Get in Touch</h4>
            <p>We're here to help. Reach out to us today!</p>

            <div className="mb-3 d-flex align-items-center">
              <FontAwesomeIcon
                icon={faPhoneAlt}
                className="contact-icons me-2"
              />
              <div>
                <strong>04734-231765</strong>
                <br />
                <strong>9633470888</strong>
              </div>
            </div>

            <div className="mb-3 d-flex align-items-center">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="contact-icons me-2"
              />
              <a
                href="mailto:mail.deepticentre@gmail.com"
                className="text-decoration-none text-dark"
              >
                <strong>mail.deepticentre@gmail.com</strong>
              </a>
            </div>

            <div className="mb-3 d-flex align-items-center">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="contact-icons me-2"
              />
              <div>
                <strong>
                  Deepti Special School and Rehabilitation Centre <br />
                  Manakala.P.O, Adoor - 691551 <br />
                  KERALA, INDIA
                </strong>
              </div>
            </div>

            <hr />
            <div>
              <h4 className="follow-us">Follow us</h4>
              <div className="social-icon d-flex gap-3 mt-2">
                <a
                  href="https://wa.me/919633470888"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark fs-4"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
                <a
                  href="https://www.instagram.com/deepticentre?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark fs-4"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="http://www.facebook.com/deepticentre"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark fs-4"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a
                  href="https://www.linkedin.com/in/your_linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark fs-4"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
              </div>
            </div>
          </motion.div>
        </Col>

        <Col md={6} className="bg-white p-4 rounded shadow-lg">
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <h4 className="send-us-message text-center mb-4">
              Send Us a Message
            </h4>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Your Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="input-field"
                  value={formData.name}
                  onChange={handleChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(
                      /[^A-Za-z\s]/g,
                      ""
                    ))
                  } // Ensures only alphabets and spaces
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Group>
                  <Form.Label>Your Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    required
                    className="input-field"
                    value={formData.email}
                    onChange={handleChange}
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" // Custom email pattern
                    title="Enter a valid email address (e.g., user@example.com)"
                  />
                </Form.Group>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={4}
                  placeholder="Your Message"
                  className="input-field"
                  value={formData.message}
                  onChange={handleChange}
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="contact-submit-btn w-100"
              >
                Send Message
              </Button>

              {responseMessage && (
                <p className="mt-3 text-center text-success">
                  {responseMessage}
                </p>
              )}
              {error && <p className="mt-3 text-center text-danger">{error}</p>}
            </Form>
          </motion.div>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col>
          <iframe
            title="Google Map"
            className="w-100 rounded shadow-sm"
            height="350"
            frameBorder="0"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.2623967213053!2d76.7114336744998!3d9.130756287388934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0611dd64f57ca9%3A0x2c803439c0f6f6d8!2sDeepti%20Special%20School%20%26%20Rehabilitation%20Centre!5e0!3m2!1sen!2sin!4v1738836792171!5m2!1sen!2sin"
            allowFullScreen
          ></iframe>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
